var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"sidebar-nav"}):(_vm.error)?_c('div',{staticClass:"sidebar-nav"},[_c('vis-error')],1):_c('sidebar-nav',{attrs:{"navItems":_vm.mavItems}})}
var staticRenderFns = []

export { render, staticRenderFns }